import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { PasswordResetRequestForm } from './PasswordResetRequestForm';

export const Route = createFileRoute('/password-reset/request')({
    component: PasswordResetRequest,
});

function PasswordResetRequest() {
    return (
        <PageController route={Route}>
            <PasswordResetRequestForm />
        </PageController>
    );
}
